import news1 from '@/static/image/news/1.png'
import news2 from '@/static/image/news/2.png'
import news3 from '@/static/image/news/3.png'
import news4 from '@/static/image/news/4.png'
import news5 from '@/static/image/news/5.png'
import news6 from '@/static/image/news/6.png'
import news7 from '@/static/image/news/7.png'
import news8 from '@/static/image/news/8.png'
import news9 from '@/static/image/news/9.png'

interface NewsItem {
  id: number
  title: string
  time: string
  desc: string
  image: string
  type: 'companynews' | 'industrytrends'
}

export const newsList: NewsItem[] = [
  {
    id: 1,
    title: '中国大件家具出海，分别都有哪些平台？',
    time: '2024-05-16',
    desc: '随着国家经济的稳定向好，国家对于欧美家具行业也会越来越倾斜，根据相关数据预计欧美家具行业将有30%的增幅，地方政策也相应出...',
    image: news1,
    type: 'industrytrends',
  },
  {
    id: 2,
    title: '跨境电商想做新类目突破，大件商品趋势好像不错?',
    time: '2024-04-30',
    desc: '在经营亚马逊初期，大家做铺货的时候，都会遇到一个问题，那就是选品。相当一部分卖家，有自己的工厂或是成熟的产品供应链，那么他们要做的事情，就是让自己产品，同步到亚...',
    image: news2,
    type: 'industrytrends',
  },
  {
    id: 3,
    title: '国际物流怎样选择渠道和方式呢？',
    time: '2024-04-22',
    desc: '外贸界的朋友除了关心产品问题外，关心的是国际物流问题，如何在收到订单后，以优惠的方式将货物寄到客户手中。那我们怎样选择运输渠道和方式呢？主要从物品的属性、时效、...',
    image: news3,
    type: 'industrytrends',
  },
  {
    id: 4,
    title: '亚马逊分仓，打响美国物流提速战',
    time: '2024-04-22',
    desc: '3月，亚马逊公布的一项服务费用，让卖家们叫苦不迭，“原本用FBA就要付订单处理费、分拣包装费、称重处理费、仓储费，现在又加上了入库配置服务费。”所谓“入库配置”...',
    image: news4,
    type: 'industrytrends',
  },
  {
    id: 5,
    title: '从美国寄快递到中国多少天?',
    time: '2024-04-22',
    desc: '随着全球化进程的不断推进,国际间的商业贸易及个人交流日益频繁。有许多消费者都喜欢在其他国家或者地区购物后,利用国际快递服务将购物物品快递送回自己国内。作为两大经...',
    image: news5,
    type: 'industrytrends',
  },
  {
    id: 6,
    title: '海运头程是什么意思？',
    time: '2024-04-22',
    desc: '海运头程指的是从发货地到目的港的第一程的运输过程。这个过程通常是指从货物起运地点到灌装或装箱的地点的运输环节。对于进口货物而言，“海运头程”指的是从装货网点到目...',
    image: news6,
    type: 'companynews',
  },
  {
    id: 7,
    title: '国际快递需要准备哪些材料？',
    time: '2024-04-22',
    desc: '随着全球化的发展，国际快递业务越来越繁荣。从个人寄送私人包裹到企业货运，在国际快递业务中，准备充足的材料是非常重要的。本文将详细解释国际快递需要准备哪些材料，让...',
    image: news7,
    type: 'companynews',
  },
  {
    id: 8,
    title: '国际物流主要做什么？',
    time: '2024-04-22',
    desc: '国际物流的任务与职责1. 供应链管理在国际物流的任务中，供应链管理是其中最重要的一个部分。在全球化和数字化的大背景下，供应链已经超越了单纯的物流范畴，成为了一个...',
    image: news8,
    type: 'companynews',
  },
  {
    id: 9,
    title: '什么是国际物流？',
    time: '2024-04-22',
    desc: '国际物流又称全球物流，指生产和消费分别在两个或两个以上的国家独立进行时，为克服生产和消费之间的空间距离和时间距离，对物资进行物理性移动的一项国际商品交易或交流活...',
    image: news9,
    type: 'companynews',
  },
]
